import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dc7f071"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-images" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "report-images__image" }, null, -1))

import { computed, PropType } from 'vue'
import { FRotateImage } from '@/features/FRotateImage'
import { ImageType } from '@/shared/types'


export default /*#__PURE__*/_defineComponent({
  props: {
  images: Array as PropType<ImageType[]>,
  rotate: Boolean,
  preview: Boolean,
},
  emits: ['rotated'],
  setup(__props, { emit }) {

const props = __props





const toothImages = computed<ImageType[]>(() => {
  return props.images.map((image) => {
    let domain = window.origin

    if (process.env.NODE_ENV === 'production') {
      domain = process.env.VUE_APP_BASE_URI
    }

    return {
      id: image.id,
      file_path: `${domain}/api/web/admin/reports/storage/${
        image.id
      }?r=${Date.now()}`,
    }
  })
})

const previewImages = computed(() =>
  props.preview ? [] : toothImages.value.map((image) => image.file_path)
)

const handleRotateImage = (): void => {
  emit('rotated')
}

return (_ctx: any,_cache: any) => {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createBlock(_component_el_skeleton, {
    loading: !__props.images.length,
    class: "report-images"
  }, {
    template: _withCtx(() => [
      _createVNode(_component_el_skeleton_item, {
        class: "report-images__scroll-item",
        variant: "image"
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_scrollbar, {
        class: "report-images__scroll",
        always: _unref(toothImages).length > 3
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toothImages), (image, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "report-images__scroll-item"
              }, [
                _createVNode(_component_el_image, {
                  class: "report-images__image",
                  src: image.file_path,
                  "preview-src-list": _unref(previewImages),
                  "initial-index": index
                }, {
                  placeholder: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 2
                }, 1032, ["src", "preview-src-list", "initial-index"]),
                (__props.rotate)
                  ? (_openBlock(), _createBlock(_unref(FRotateImage), {
                      key: 0,
                      "image-id": image.id,
                      onRotated: handleRotateImage
                    }, null, 8, ["image-id"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["always"])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})